/* unplugin-vue-components disabled */import { render } from "./logo.vue?vue&type=template&id=374cac5b&scoped=true"
import script from "./logo.vue?vue&type=script&lang=js"
export * from "./logo.vue?vue&type=script&lang=js"

import "./logo.vue?vue&type=style&index=0&id=374cac5b&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-374cac5b"],['__file',"src/controls/logo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "374cac5b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('374cac5b', __exports__)) {
    api.reload('374cac5b', __exports__)
  }
  
  module.hot.accept("./logo.vue?vue&type=template&id=374cac5b&scoped=true", () => {
    api.rerender('374cac5b', render)
  })

}


export default __exports__